<pf-listview [title]="'admin.product.title' | translate" [items]="products" [addRouterLink]="'/addproduct'"
    [headerExtraButtonText]="'products.order.discountedProducts' | translate"
    [headerExtraButtonLink]="'/orderdiscountedproducts'"
    [headerExtraButtonText2]="'products.order.noveltyProducts' | translate"
    [headerExtraButtonLink2]="'/ordernoveltyproducts'"
    [searchPlaceholder]="'admin.product.searchPlaceholder' | translate"
    [saveButtonText]="('admin.save' | translate | uppercase)" [useDragDrop]="true" (save)="updateProductsOrder()"
    [hasSearchSection]="true" [useSaveButton]="true">

    <ng-template #itemTemplate let-product let-i="index">
        <div class="product-row-layout" [routerLink]="product.routerLink">

            <div class="name-section">
                <div class="product-name">
                    @if (product.routerLink !== 'morte_taska') {
                    <b class="product-title">{{ product.author }} : {{ product.title }}</b>
                    }
                </div>
            </div>
            <div class="badges">
                @if (product.quantityOfSupply! > 0) {
                <span class="stock">{{ product.quantityOfSupply }} db</span>
                } @else if (product.quantityOfSupply === 0) {
                <b class="status-red">{{'admin.product.outOfStock' | translate}}</b>
                }

                @if (product.discountLimitedUntil !== null) {
                <span class="divider"> /</span>
                <b class="status-red">{{'admin.product.discountLimitedUntil' | translate}}</b>
                }

                @if (product.discountPriceActive) {
                <span class="divider"> /</span>
                <b class="status-red">{{'admin.product.discounted' | translate}}</b>
                }
            </div>

        </div>
    </ng-template>
</pf-listview>
